<div class="el-page">
  <!-- ============ La barre d'outils : tous les filtres ============ -->
  <div class="el-tools">
    <input
      type="text"
      class="el-search"
      [ngModel]="search()"
      (ngModelChange)="search.set($event)"
      [placeholder]="'eventsList.searchPlaceholder' | translate"
    />
    <input
      type="text"
      class="el-input"
      [ngModel]="city()"
      (ngModelChange)="city.set($event)"
      [placeholder]="'eventsList.cityPlaceholder' | translate"
    />
    <input type="date" class="el-input el-date" [ngModel]="fromDate()" (ngModelChange)="fromDate.set($event)" />
    <span class="el-date-sep">→</span>
    <input type="date" class="el-input el-date" [ngModel]="toDate()" (ngModelChange)="toDate.set($event)" />
    <button type="button" class="el-chip" [class.is-on]="emptyOnly()" (click)="emptyOnly.set(!emptyOnly())">
      {{ 'eventsList.emptyOnly' | translate }}
    </button>
    <button *ngIf="hasPrice()" type="button" class="el-chip" [class.is-on]="paidOnly()" (click)="paidOnly.set(!paidOnly())">
      {{ 'eventsList.paidOnly' | translate }}
    </button>
    <button *ngIf="hasRecurring()" type="button" class="el-chip" [class.is-on]="recurringOnly()" (click)="recurringOnly.set(!recurringOnly())">
      {{ 'eventsList.recurringOnly' | translate }}
    </button>
  </div>

  <div class="el-sports">
    <button type="button" class="el-chip" [class.is-on]="sport() === null" (click)="sport.set(null)">
      {{ 'eventsList.allSports' | translate }}
    </button>
    <button
      type="button"
      class="el-chip"
      *ngFor="let entry of sports()"
      [class.is-on]="sport() === entry"
      (click)="toggleSport(entry)"
    >
      {{ entry }}
    </button>
  </div>

  <!-- ============ La carte, à la demande ============ -->
  <button type="button" class="el-map-toggle" (click)="mapOpen.set(!mapOpen())">
    <b>{{ mapOpen() ? '▾' : '▸' }} {{ (mapOpen() ? 'eventsList.hideMap' : 'eventsList.showMap') | translate }}</b>
    <span>{{ 'eventsList.mapNote' | translate }}</span>
  </button>
  <google-map *ngIf="mapOpen()" [options]="mapOptions" height="420px" width="100%">
    <map-marker
      *ngFor="let event of filteredEvents()"
      [position]="{ lat: event.location.lat, lng: event.location.lon }"
      [options]="{ draggable: false, clickable: true, title: event.title }"
      (mapClick)="selectEvent(event)"
    />
  </google-map>

  <!-- ============ La liste, surface de travail ============ -->
  <div class="el-tablebox">
    <table class="el-table">
      <thead>
        <tr>
          <th>{{ 'eventsList.start' | translate }}</th>
          <th>{{ 'eventsList.activity' | translate }}</th>
          <th>{{ 'eventsList.fill' | translate }}</th>
          <th>{{ 'eventsList.level' | translate }}</th>
          <th *ngIf="hasPrice()">{{ 'eventsList.price' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let event of filteredEvents()" class="is-clickable" (click)="selectEvent(event)">
          <td>
            <span class="el-days" [attr.data-urgency]="urgency(event)">{{ dayBadge(event) }}</span>
            <small class="el-datecell">{{ event.startDate | date: 'EEE dd/MM, HH:mm' }}</small>
          </td>
          <td>
            <span class="el-act">
              <b>{{ event.title }}</b>
              <small>
                <span class="el-sportchip">{{ event.sportTitle }}</span>
                · {{ event.locationAddress }}
              </small>
            </span>
          </td>
          <td>
            <span class="el-fill">
              <span class="el-fill-track">
                <span class="el-fill-value" [class.is-alert]="partners(event) === 0" [style.width]="fillWidth(event)"></span>
              </span>
              <b [class.is-alert-text]="partners(event) === 0">{{ partners(event) }}/{{ partnerCapacity(event) }}</b>
            </span>
          </td>
          <td class="el-level">
            <ng-container *ngIf="event.acceptAnyLvl">{{ 'eventsList.anyLevel' | translate }}</ng-container>
            <ng-container *ngIf="!event.acceptAnyLvl">{{ event.level }}</ng-container>
          </td>
          <td *ngIf="hasPrice()">
            <span class="el-price" *ngIf="event.price && event.price > 0">{{ event.price / 100 | number: '1.0-2' }} €</span>
            <span class="el-free" *ngIf="!event.price">{{ 'eventsList.free' | translate }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="el-empty" *ngIf="filteredEvents().length === 0">{{ 'eventsList.empty' | translate }}</p>
  </div>
  <p class="el-count">
    {{ 'eventsList.count' | translate: { count: filteredEvents().length } }} ·
    {{ 'eventsList.fillNote' | translate }}
  </p>

  <!-- ============ La fiche, glisse à droite ============ -->
  <p-sidebar
    [visible]="selectedEvent() !== null"
    (visibleChange)="!$event && closeDetail()"
    position="right"
    styleClass="el-detail-sidebar"
    [modal]="true"
    [dismissible]="true"
    [showCloseIcon]="true"
  >
    <bo-event-detail *ngIf="selectedEvent()" [event]="selectedEvent()!" />
  </p-sidebar>
</div>
